import { render, staticRenderFns } from "./sparepartsadd.vue?vue&type=template&id=d8ecc7d2&"
import script from "./sparepartsadd.vue?vue&type=script&lang=js&"
export * from "./sparepartsadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports